import { useQuery } from '@tanstack/react-query';

import { getOrganizationDefaults } from '@/modules/common/api/organization.api';

export const ORGANIZATION_DEFAULTS_QUERY_KEY = ['organization-defaults'];

const STALE_TIME = 1000 * 60 * 30; // 30 minutes

export const useOrganizationDefaults = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ORGANIZATION_DEFAULTS_QUERY_KEY,
    queryFn: () => getOrganizationDefaults(),
    staleTime: STALE_TIME,
    enabled: options?.enabled,
  });
};
